// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__2trRm","active":"downloadDropdown_active__3DXdS"};